import SupplierRequest from '@/shared/infrastructure/suppliers/Request'

const actions = {
  fetchSupplierInfo(action, id) {
    return SupplierRequest.fetchSupplierInfo(id)
  },
  inviteSuppliersToChat(action, payload) {
    return SupplierRequest.inviteSuppliersToChat(payload)
  },
  fetchSupplierPreviewInfo(action, id) {
    return SupplierRequest.fetchSupplierPreviewInfo(id)
  },
}

export default actions
